/* eslint-disable semi,semi-style */
import 'whatwg-fetch';
import { typeOf } from './index';
import { host, env } from './env';
import { LOCAL_COMPANY, SOURCE } from '@/util/constants';
import { message } from 'antd';
import { useInterceptors } from '@/util/sign';
import ticket from './ticket';
// const codeMessage = {
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功。',
//   202: '一个请求已经进入后台排队（异步任务）。',
//   204: '删除数据成功。',
//   400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//   401: '用户没有权限（令牌、用户名、密码错误）。',
//   403: '用户得到授权，但是访问是被禁止的。',
//   404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//   406: '请求的格式不可得。',
//   410: '请求的资源被永久删除，且不会再得到的。',
//   422: '当创建一个对象时，发生一个验证错误。',
//   500: '服务器发生错误，请检查服务器。',
//   502: '网关错误。',
//   503: '服务不可用，服务器暂时过载或维护。',
//   504: '网关超时。',
// }
/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options = {}) {
  const defaultOptions = {
    credentials: 'include',
    headers: {
      env: 'pc',
    },
  };

  options.params = {
    ...options.params,
    source: SOURCE,
  };

  const supplierId = localStorage.getItem(LOCAL_COMPANY);
  if (supplierId) {
    options.params = {
      ...options.params,
      supplierId,
      identity: 'manufacturer',
    };
  }

  // if (env === 'dev' && ticket) {
  //   options.headers = {
  //     ...options.headers,
  //     ticket,
  //   };
  // }

  const newOptions = { ...defaultOptions, ...options };
  if (newOptions.method) {
    newOptions.method = newOptions.method.toUpperCase();
  }
  if (typeOf(newOptions.params) === 'object') {
    const queryString = Object.keys(newOptions.params)
      .map(it => {
        const v = newOptions.params[it];
        if (typeOf(v) !== 'undefined' && v !== null && v !== '') {
          return `${it}=${encodeURIComponent(v)}`;
        }
        return '';
      })
      .filter(it => it)
      .join('&');

    url += (url.indexOf('?') === -1 ? '?' : '&') + queryString;
    delete newOptions.params;
  }
  if (newOptions.method === 'POST' || newOptions.method === 'PUT' || newOptions.method === 'DELETE') {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
      };
      if (typeof newOptions.body === 'object') {
        newOptions.body = JSON.stringify(newOptions.body);
      }
    } else {
      newOptions.headers = {
        Accept: 'application/json',
        ...newOptions.headers,
      };
    }
  }
  const requestOptions = useInterceptors({ url, ...newOptions });
  return new Promise((resolve, reject) => {
    fetch(/^https?/.test(url) ? url : host + url, requestOptions)
      // CORS错误等
      // .then((response) => {
      //   if (response instanceof Error) {
      //     notification.error({
      //       message: response.message,
      //     })
      //     throw response
      //   }
      //   return response
      // })
      // .then((response) => {
      //   if (response.status >= 200 && response.status < 300) {
      //     return response
      //   }
      //   const errortext = codeMessage[response.status] || response.statusText
      //   notification.error({
      //     message: <div style={{ wordBreak: 'break-all' }}>请求错误 {response.status}: {response.url}</div>,
      //     description: errortext,
      //   })
      //   const error = new Error(errortext)
      //   error.name = response.status
      //   error.response = response
      //   throw error
      // })
      .then(response => {
        if (newOptions.method === 'DELETE' || response.status === 204) {
          return response.text();
        }
        return response.json();
      })
      .then(response => {
        // if (response.code === '300') {
        //   window.location.replace(response.data.redirectUrl)
        //   return
        // } else if (response.code === '302') {
        //   notification.error({
        //     message: '权限认证',
        //     description: <div style={{ wordBreak: 'break-all' }}><code>{response.data.requestPath}</code><br />抱歉，你没有该操作的权限！<a href={response.data.redirectUrl} target="_blank">点我去申请</a></div>
        //   })
        //   return
        // }
        if (response.success || response.code === 10000) {
          resolve(response.data);
        } else if (response.status === 10008) {
          reject(response);
        } else {
          // notification.error({
          //   message: response.msg,
          // })
          reject(response);
          message.error(response.msg || '未知原因');
        }
      })
      .catch(e => {
        console.error(e);
        reject(e);
      });
  });
}
